import { useSelector } from 'react-redux';
import useFirebase from '../../../../useFirebase';

function useSetRules() {
    const {
        postCollectionData,
        getCollectionData
    } = useFirebase();

    const { 
        setRulesData 
    } = useSelector(({ setRules }) => setRules);

    function handleTimeSupervision(e, deviceSelected) {
		// console.log(e)
		// const tempSetRulesData = [...setRulesData];
		const { checked } = e.target;

		const collectionPayload = {
			...setRulesData,
			enableSupervision: checked
		}

		// console.log(collectionPayload);

		postCollectionData(deviceSelected, collectionPayload);
		getCollectionData(deviceSelected);
	}

    return {
        handleTimeSupervision
    }
}

export default useSetRules;